import { isSWSGQLError } from '@/utilities/graphQLClient';

import { sentryCaptureMessage } from '@/components/Sentry';

const KNOWN_ERROR_CODES = {
  'HTTP-413': `You're trying to import too many transactions at once. We're currently working on a fix. In the meantime, please remove some of the latest ones and try again.`,
} as const;

const defaultErrorMessage = `Your changes couldn't be saved. Please try again.`;

export const getErrorMessage = (error: unknown) => {
  if (!isSWSGQLError(error)) return defaultErrorMessage;

  // Payload Too Large
  // This was previously sniffing the error status code, but since we no longer store that on gql
  // errors, we need to do a hacky parse of the error message.
  if (error.code === 'INTERNAL_SERVER_ERROR' && error.message.includes('413'))
    return KNOWN_ERROR_CODES['HTTP-413'];

  // Capture unknown errors
  sentryCaptureMessage({
    team: 'wombats',
    message: `${error.code} - ${error.message}`,
  });
  return defaultErrorMessage;
};
